import React from 'react';
import type { StatusTone } from '../../utils/monitorStatus';
import '../ScoreBadge/ScoreBadge.css';

interface StatusBadgeProps {
  tone: StatusTone;
  children: React.ReactNode;
  large?: boolean;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ tone, children, large }) => (
  <span className={`score-badge score-badge--${tone}${large ? ' score-badge--large' : ''}`}>
    {children}
  </span>
);

export default StatusBadge;
